export default {
  /**
   * Trạng thái của form
   */
  FormState: {
    Add: "Thêm mới",
    View: "Xem",
    Edit: "Sửa",
    Duplicate: "Nhân bản",
    QuickAdd: "Thêm nhanh"
  },
  /**
   * Giới tính
   */
  Gender: {
    Female: "Nữ",
    Male: "Nam",
    Other: "Khác"
  },
  /**
   * toán tử filter
   */
  FilterHeader: {
    Contains: "Chứa",
    Notcontains: "Không chứa",
    StartsWith: "Bắt đầu với",
    EndsWith: "Kết thúc với",
    Null: "(Trống)",
    NotNull: "(Không trống)",
    Equals: "Bằng",
    NotEquals: "Khác",
    GreaterThan: "Lớn hơn",
    GreaterThanEquals: "Lớn hơn hoặc bằng",
    LessThan: "Nhỏ hơn",
    LessThanEquals: "Nhỏ hơn hoặc bằng",
    Between: "Trong khoảng"
  },

  OrganizationUnitType: {
    Corporations: "Tổng công ty",
    Group: "Tập đoàn",
    Subsidiaries: "Công ty con",
    Branch: "Chi nhánh",
    Representative: "Văn phòng đại điện",
    Office: "Văn phòng",
    Center: "Trung tâm",
    Department: "Phòng ban",
    Team: "NHóm/tổ/đội",
    Factory: "Phân xưởng"
  },
  EmployeeType: {
    Probation: "Thử việc",
    Office: "Chính thức",
    Manage: "Quản lý",
  },
  Period: {
    ThisDay: "Hôm nay",
    ThisWeek: "Tuần này",
    FirstWeekToPresent: "Đầu tuần tới hiện tại",
    ThisMonth: "Tháng này",
    FirstMonthToPresent: "Đầu tháng tới hiện tại",
    ThisQuarter: "Quý này",
    FirstQuarterToPresent: "Đầu quý tới hiện tại",
    ThisYear: "Năm nay",
    FirstYearToPresent: "Đầu năm tới hiện tại",
    SixFirstMonth: "Sáu tháng đầu năm",
    SixLastMonth: "Sáu tháng cuối năm",
    January: "Tháng 1",
    February: "Tháng 2",
    March: "Tháng 3",
    April: "Tháng 4",
    May: "Tháng 5",
    June: "Tháng 6",
    July: "Tháng 7",
    August: "Tháng 8",
    September: "Tháng 9",
    October: "Tháng 10",
    November: "Tháng 11",
    December: "Tháng 12",
    FiscalI: "Quý 1",
    FiscalII: "Quý 2",
    FiscalIII: "Quý 3",
    FiscalIV: "Quý 4",
    Yesterday: "Hôm qua",
    LastWeek: "Tuần trước",
    LastMonth: "Tháng trước",
    LastQuarter: "Quý trước",
    LastYear: "Năm trước",
    Tomorrow: "Ngày mai",
    NextWeek: "Tuần sau",
    NextMonth: "Tháng sau",
    NextQuarter: "Quý sau",
    NextYear: "Năm sau",
    Custom: "Tùy chọn",
  }
};
